import { useParseCubicBezier } from '~/utils/useParseCubicBezier';

export const EaseOutQuint = useParseCubicBezier(
  'cubic-bezier(0.22, 1, 0.36, 1)',
);
